/**
 * Simple deep clone utility for plain objects and arrays.
 */
export function clone<T>(value: T): T {
  return JSON.parse(JSON.stringify(value)) as T;
}
